import { Modal } from 'bootstrap';

document.addEventListener('DOMContentLoaded', () => {
  let modal_id = '#product-detail-media-modal'
  if (document.querySelector(modal_id)) {
    let modal = new Modal(document.querySelector(modal_id), { backdrop: false });

    document.querySelectorAll('.media-modal-trigger').forEach((trigger) => {
      trigger.addEventListener('click', (evt) => {
        evt.preventDefault();
        let carousel_index = evt.currentTarget.getAttribute('data-wf-index');
        window.wf_carousel['pdp-modal-carousel'].slideTo(carousel_index, 0);
        modal.show();
        return false;
      })
    })
  }
})